/* eslint-disable @angular-eslint/no-input-rename */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AccountsSVGIcons, ConsumerSVGIcons } from './product-icons-helper';
@Component({
  selector: 'dx-product-image',
  templateUrl: './product-image.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class ProductImageComponent {
  @Input({ required: true }) product: string;
  @Input() icon!: string;
  @Input({ required: true }) flowType: string;
  @Input() size = '120px';

  // TODO: this was intended to be a temp solution so that icons come from a single source of logic
  // SAD CODE MAKES EMAD SAD :(
  // Clean up after this feature is done: https://dev.azure.com/cudirect/Origence/_workitems/edit/262511 -->
  // Search all instances of dx-product-image
  public setIconClass() {
    if (!!this.icon?.length) return this.icon;

    if (!this.product || !this.flowType) {
      return 'us-currency';
    }
    return this.flowType.toLowerCase() === 'ola'
      ? ConsumerSVGIcons(this.product.toLowerCase())
      : AccountsSVGIcons(this.product.toLowerCase());
  }
}
